import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import * as forgot from '../state';
import { requestReset } from '../state';

@Component({
  selector: 'tc-forgot-page',
  templateUrl: './forgot-page.component.html',
  styleUrls: ['./forgot-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotPageComponent implements OnInit {
  public pending$ = this.store$.pipe(select(forgot.select.pending));
  public error$ = this.store$.pipe(select(forgot.select.error));
  public success$ = this.store$.pipe(select(forgot.select.success));
  public value: forgot.RequestPasswordReset | undefined;

  constructor(private route: ActivatedRoute, private store$: Store<forgot.State>) {}

  ngOnInit(): void {
    if (this.route.snapshot.queryParamMap.has('email')) {
      const email = this.route.snapshot.queryParamMap.get('email')!;
      this.value = { email };
      this.onSubmit({ email });
    }
  }

  public onSubmit($event: forgot.RequestPasswordReset): void {
    this.store$.dispatch(requestReset({ payload: $event }));
  }
}
